export const GA_MEASUREMENT_ID = "G-3WCVQP4XZX";

const GA_SCRIPT_SRC = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
const LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1", "[::1]"]);

export function isAnalyticsEnabled(hostname = window.location.hostname) {
  return !LOCAL_HOSTNAMES.has(hostname);
}

export function initGoogleAnalytics() {
  if (!isAnalyticsEnabled()) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });

  const script = document.createElement("script");
  script.async = true;
  script.src = GA_SCRIPT_SRC;
  document.head.append(script);
}
